import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import $ from "jquery";
import ReqService from './../../request/service';
import Waiter from './../../assets/gif/blueCircle.gif';
import { createGlobalStyle } from 'styled-components';
import axios from "axios";
import {stringToHex,validateToken} from "./../forms/validator";
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../../constants';
const GlobalStyles = createGlobalStyle`
.table {
		border:0px dotted #e0e0e0;
}
table.table th span { font-size:1rem; color:#909090; font-weight:400;}
table.table td  { font-size:0.85rem; color:#202020; font-weight:400; padding:8px 2px;}
	.dataTables_filter input[type=search]
{
	border-radius:50rem!important;
	padding-left:1rem;
	padding-right:1rem;
	padding-top:0.2rem;
	padding-bottom:0.2rem;
	
}
div.dataTables_wrapper div.dataTables_length select {
   border-radius:50rem!important;
   padding-left:1rem;
	padding-right:1rem;
	padding-top:0.2rem;
	padding-bottom:0.2rem;
   width:120px;
}
div.dataTables_wrapper div.dataTables_length label{
	color:#404040;
	font-weight: 300;
    font-size: 0.875rem;
}
div.dataTables_wrapper div.dataTables_filter label {
    color:#404040;
	font-weight: 300;
    font-size: 0.875rem;
}
table.dataTable.table-striped>tbody>tr.odd>* {
    box-shadow: inset 0 0 0 9999px rgb(200 250 150 / 5%)!important;
}
.page-link {
	border:0px!important;
	font-size:12px;
}
.active>.page-link, .page-link.active {
    z-index: 3;
    color: #fff;
    background-color: #11b5ff;
    border-color: #11b5ff;
	box-shadow:1px 1px #999;
	border-radius:50rem;
}
.dataTables_info{
	font-size:12px;
	color:#495057;
}
`;

const JComponent = (props) => {
	const [implAgencyList,setImplAgencyList]=useState([]);
	const [cols,setCols]=useState([]);
	const [rows,setRows]=useState([]);
	const [fetchOnReq,setFecthOnReq]=useState(false);
	let _TX=1;
	useEffect(()=>{ 
		setCols(['Name','Email','Mobile.No','Department','Role']);
		if(_TX==1){
			_TX++;
			loadImplAgencyList();
			let _url="/api/user/getUsers.php";
			let _d={
				token:localStorage.getItem("_lio"),
				email:localStorage.getItem("_xoxem"),
			};
			let idata=stringToHex(JSON.stringify(_d));
			let _rows=[];
			setRows([]);	
			setFecthOnReq(true);	
			var config = {
				method: 'post',
				url: API_CORE_SERVER+_url,
				headers: { 
					'Content-Type': 'application/x-www-form-urlencoded',
					//'Content-Type': 'application/json', 
				},
				data:"i="+idata
			  };
			  axios(config).then(response=>{
				if(response.status===200 && response.data){
					let data=response.data;
					validateToken(data.status);
					if(data.status===1 && data.data && data.data.length>0){
						let records=data.data;
						for(let i=0;i<records.length;i++){
							try{
								let userNo=records[i].userNo;
								let emailId=records[i].emailId;
								let createrId=records[i].email;
								let rec=JSON.parse(records[i].data);
								_rows.push({ 
									fname:rec.fname,
									mname:rec.mname,
									lname:rec.lname,
									gender:rec.gender,
									implementAgency:rec.implementAgency,
									email:rec.email,
									phone:rec.phone,
									userNo:userNo,
									createdBy:createrId,
									role:rec.role
								});
							}catch(e){
								
							}
						}
					}
				}
				setRows(_rows);
				setFecthOnReq(false);
			});
		}
	},[]);
	
	useEffect(()=>{
		setTimeout(()=>{
		window["initTable"]("w3DListTable")
		},2000);
		
	},[rows])
	const getImplAgencyById=(_id)=>{
		for(let i=0;i<implAgencyList.length;i++){
			if(implAgencyList[i].implAgencyId===_id) return(implAgencyList[i].implAgencyName);
		}
		return(_id);
	}
	const loadImplAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_impl_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setImplAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	
	return (
        <>
		<GlobalStyles />
		<div className='card bg-light'>
		<div className="card-body">
		{fetchOnReq===true && 
			<>
				<img src={Waiter} className='waiter-md'/>
			</>
		}
		{(fetchOnReq===false && rows.length>=1) && 
		
			<table id="w3DListTable" className="table table-sm" style={{width:"99%"}}>
				<thead>
					<tr>
						<td><span>Slno</span></td>
						{cols.map((item,i)=>{
							return(
								<th key={'tfx423_'+i}><span>{item}</span></th>	
							)
						})
						}
					  
					</tr>
				</thead>
				<tbody>
					{rows.map((item,i)=>{
							return(
								<tr key={'t423_'+i}>
									<td>{(i+1)}</td>
									<td>{item.fname+" "+item.mname+" "+item.lname}</td>
									<td>{item.email}</td>
									<td>{item.phone}</td>
									<td>{getImplAgencyById(item.implementAgency)}</td>
									<td>{item.role}</td>
								</tr>	
							)
				   })
				   }
				</tbody>
				
			</table>
		}
		</div>	
		</div>
        </>
    )
}

export default JComponent;